module.exports = __webpack_public_path__ + "img/city_select.f5048ca7.png";